import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
declare var ga: any;

@Component({
  selector: 'app-account-details-section',
  templateUrl: './account-details-section.component.html',
  styleUrls: ['./account-details-section.component.scss'],
  providers: []
})
export class AccountDetailsSectionComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/account-details');
      ga('send', 'pageview');
    }
  }

}
